import type { ColumnDef } from "@tanstack/react-table";

import { multiValueAttrColumn } from "@/components/DataTable/Columns/multiValueAttrColumn";
import { personColumn } from "@/components/DataTable/Columns/personColumn";
import { simpleTextColumn } from "@/components/DataTable/Columns/simpleTextColumn";

import type { BoardMemberTableRow } from "../-types";

import { actionsColumn } from "./actionsColumn";

/** カラムID（テーブル表示用） */
export const Columns = {
  PERSON: "person",
  BOARD_TYPE_NAME: "boardTypeName",
  JOB_TYPES: "jobTypes",
  DEPARTMENT_AND_POSITIONS: "departmentAndPositions",
  PLACES: "places",
} as const;

/** APIソートカラム名（API通信用） */
export const SortColumns = {
  PERSON_NAME: "PERSON_NAME",
  WORKER_TYPE: "WORKER_TYPE",
  JOB_TYPE: "JOB_TYPE",
  PLACE: "PLACE",
} as const;

/** テーブルカラムID → APIソートカラム名のマッピング */
export const columnToSortColumn: Record<string, string> = {
  [Columns.PERSON]: SortColumns.PERSON_NAME,
  [Columns.BOARD_TYPE_NAME]: SortColumns.WORKER_TYPE,
  [Columns.JOB_TYPES]: SortColumns.JOB_TYPE,
  [Columns.PLACES]: SortColumns.PLACE,
};

/** APIソートカラム名 → テーブルカラムIDのマッピング */
export const sortColumnToColumn: Record<string, string> = {
  [SortColumns.PERSON_NAME]: Columns.PERSON,
  [SortColumns.WORKER_TYPE]: Columns.BOARD_TYPE_NAME,
  [SortColumns.JOB_TYPE]: Columns.JOB_TYPES,
  [SortColumns.PLACE]: Columns.PLACES,
};

export function useBoardMemberColumns(): ColumnDef<BoardMemberTableRow>[] {
  return [
    personColumn(Columns.PERSON, {
      i18nKey: "person",
      minWidth: "240px",
      sortable: true,
    }),
    simpleTextColumn(Columns.BOARD_TYPE_NAME, {
      i18nKey: "boardMemberType",
      minWidth: "160px",
      sortable: true,
    }),
    multiValueAttrColumn(Columns.JOB_TYPES, {
      i18nKey: "jobType",
      minWidth: "160px",
      sortable: true,
      primaryLabelKey: "hrPrimary",
    }),
    multiValueAttrColumn(Columns.DEPARTMENT_AND_POSITIONS, {
      i18nKey: "departmentAndPositions",
      minWidth: "200px",
      sortable: false,
      primaryLabelKey: "hrPrimary",
    }),
    multiValueAttrColumn(Columns.PLACES, {
      i18nKey: "assignedLocations",
      minWidth: "160px",
      sortable: true,
      primaryLabelKey: "primary",
    }),
    actionsColumn(),
  ] satisfies ColumnDef<BoardMemberTableRow>[];
}
